import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';

import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import GlobalThrobberComponent from '../components/global_throbber_component';
import { useNotification } from '../components/global_noification_component';
const API_BASE = process.env.REACT_APP_API_BASE
const API_VERSION = process.env.REACT_APP_API_ENVIRONMENT
const SITE_ENVIRONMENT = process.env.REACT_APP_SITE_ENVIRONMENT
const DiscordOnboardingPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const notify = useNotification();

    useEffect(() => {
        setLoading(true);
        notify('info', 'Starting Discord authentication...');
        const params = new URLSearchParams(location.search);
        const userData = {};
        params.forEach((value, key) => {
            userData[key] = value;
            Cookies.set(key, value, { expires: 7, secure: true, sameSite: 'strict' });
        });

        fetch(`${API_BASE}/${API_VERSION}/public/oAuth/discord`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...userData, environment: SITE_ENVIRONMENT })
        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            })
            .then(data => {
                Cookies.set('user_id', data.user_id, { expires: 7, secure: true, sameSite: 'strict' });
                Cookies.set('discord_id', data.discord_id, { expires: 7, secure: true, sameSite: 'strict' });
                Cookies.set('username', data.username, { expires: 7, secure: true, sameSite: 'strict' });
                Cookies.set('discriminator', data.discriminator, { expires: 7, secure: true, sameSite: 'strict' });
                Cookies.set('avatar', data.avatar, { expires: 7, secure: true, sameSite: 'strict' });
                Cookies.set('banner', data.banner, { expires: 7, secure: true, sameSite: 'strict' });
                Cookies.set('global_name', data.global_name, { expires: 7, secure: true, sameSite: 'strict' });
                Cookies.set('email', data.email, { expires: 7, secure: true, sameSite: 'strict' });
                Cookies.set('refresh_token', data.refresh_token, { expires: 7, secure: true, sameSite: 'strict' });
                Cookies.set('logged_in', true, { expires: 7, secure: true, sameSite: 'strict' });
                notify('success', 'Discord authentication successful');
                setLoading(false);
                navigate('/');
            })
            .catch(error => {
                setLoading(false);
                console.error(error);
                notify('error', `Discord authentication failed: ${error.message}`);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search, navigate]);

    return (
        <>
            <Helmet>
                <title>Discord Authentication - Ballhead</title>
                <meta property="og:title" content="Discord Authentication - Ballhead" key="og:title" />
                <meta property="og:description" content="Authenticating with Discord..." key="og:description" />
                <meta property="og:image" content="https://cdn.ballhead.app/web_assets/logo.png" key="og:image" />
                <meta property="og:url" content={`${window.location.origin}/discord-link`} key="og:url" />
                <meta property="og:type" content="website" key="og:type" />
                <meta name="twitter:card" content="summary_large_image" key="twitter:card" />
                <meta name="twitter:title" content="Discord Authentication - Ballhead" key="twitter:title" />
                <meta name="twitter:description" content="Authenticating with Discord..." key="twitter:description" />
                <meta name="twitter:image" content="https://cdn.ballhead.app/web_assets/logo.png" key="twitter:image" />
            </Helmet>
            {loading && <GlobalThrobberComponent />}
        </>
    );
};

export default DiscordOnboardingPage;